.shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: var(--w-border-strong) transparent;
}

.bottom {
  flex: none;
  padding: var(--space-8) 0 max(var(--space-8), var(--safe-bottom));
  background: var(--w-bg);
}

/* Typing on a phone: the field sits right on the keyboard. The quiet line goes
   (the keyboard covers that strip anyway) and so does the home-indicator gap. */
:global(:root[data-fullscreen]) .bottom:focus-within {
  padding-bottom: var(--space-8);
}

:global(:root[data-fullscreen]) .bottom:focus-within .note {
  display: none;
}

/* Disclaimer and "Działa na UNITIVO" share one quiet line under the composer. */
.note {
  margin: var(--space-6) var(--space-12) 0;
  color: var(--w-faint);
  font-size: 11px;
  line-height: 1.4;
  text-align: center;
  text-wrap: balance;
}

.brand {
  color: inherit;
  text-decoration: none;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.brand strong {
  font-weight: 650;
  letter-spacing: 0.04em;
}

@media (hover: hover) and (pointer: fine) {
  .brand:hover {
    color: var(--w-muted);
  }
}

.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-12);
  height: 100%;
  padding: var(--space-24);
  color: var(--w-muted);
  text-align: center;
}

.state p {
  margin: 0;
  max-width: 28ch;
  text-wrap: balance;
}

.stateButton {
  min-height: 40px;
  padding: 0 var(--space-16);
  border: 1px solid var(--w-border-strong);
  border-radius: 12px;
  background: transparent;
  font-weight: 600;
  cursor: pointer;
}
